import { Component, Input, Output, EventEmitter } from '@angular/core';
import {
  certificateMedalAnimationWrapper,
  circleGrowBounce,
  growBounce,
  smoothGrowBounce,
} from './certificate-medal-animations';

@Component({
  selector: 'lp2-certificate-medal',
  templateUrl: './certificate-medal.component.html',
  styleUrls: ['./certificate-medal.component.scss'],
  animations: [certificateMedalAnimationWrapper, circleGrowBounce, growBounce, smoothGrowBounce],
})
export class CertificateMedalComponent {
  @Input() level: number;
  @Output() isAnimationDone: EventEmitter<boolean> = new EventEmitter();
  displayBadge = true;
  constructor() {}

  playAgain() {
    this.displayBadge = !this.displayBadge;
  }

  setAnimationDone() {
    this.isAnimationDone.emit(true);
  }
}



// WEBPACK FOOTER //
// ./ts/app/certificates/certificate-medal/certificate-medal.component.ts